import { render, staticRenderFns } from "./CmsMgmt.vue?vue&type=template&id=2cf12cb1&scoped=true&"
import script from "./CmsMgmt.vue?vue&type=script&lang=js&"
export * from "./CmsMgmt.vue?vue&type=script&lang=js&"
import style0 from "./CmsMgmt.vue?vue&type=style&index=0&id=2cf12cb1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf12cb1",
  null
  
)

export default component.exports